@import "@zvuk-b2b/react-uikit/ui/styles/_mixins";

.CleanMain {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex: auto;
    width: 100%;
    min-width: $mobile-width-xs;
    padding: $ceil * 3 $ceil * 2;
    background-color: $color-white;

    &Header {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100%;
        max-width: $mobile-width-m;

        @include media-mobile {
            margin-top: 0;
            margin-bottom: $ceil;
        }

        @include media-desktop {
            margin-top: $ceil;
        }

        &Hidden {
            height: 0;
            overflow: hidden;
            margin: 0;
        }
    }

    &Section {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 100%;
        margin: 0 auto;
        padding-top: $ceil * 6;

        &Content {
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: fit-content;
            margin: 0 auto;
            max-width: $mobile-width-m;

            @include media-mobile {
                border-radius: 0;
            }

            @include media-desktop {
                flex: 1 1 auto;
            }
        }
    }

    &ContactButton {
        position: fixed;

        @include media-mobile {
            position: absolute;
            left: 0;
        }

        @include media-desktop {
            right: $ceil * 3;
            bottom: $ceil * 3;
            z-index: $z-index-layer-l;
        }
    }

    &LogoutButton {
        position: absolute;
        width: fit-content;

        @include media-mobile {
            top: -4px;
            right: 0;
        }

        @include media-desktop {
            top: $ceil * 3;
            right: $ceil * 3;
        }
    }
}
